export default {
  YELLOW: '#FFDA00',
  PURPLE: '#5333ed',
  GREY: '#dadada',
  BLACK: 'rgba(0, 0, 0, 0.8)',
  SUCCESS: '#27AE60',
  RED: '#EB5757',
  BLUE: '#2F80ED',
  DARK_BLUE: '#1F3A93',
  WHITE: '#ffffff',
  WHITE_F0: '#F0F2F5',
  MARKETPLACE_DARK_GREY: '#908d9f',
  MARKETPLACE_GREY: '#F0F2F5',
  MARKETPLACE_BLACK: '#151035',
  MARKETPLACE_GREEN: '#42D483',
  GREEN: '#52C41A',
  GREY_D9: '#D9D9D9',
  GREY_B4: '#B4B8BC',
  GREY_49: '#495057',
  GREY_DEE: '#dee2e6',
  GREY_A1A1: '#A1A1A1',
};
